import React, {useState, useEffect, useContext, useRef, Ref} from "react";
import {Card, Button, Text, Flex, Box} from "rebass";
import {CardHeader, SliderInput} from "../../../../../Components";
import {Patient} from "../../../../../Types";
import {Checkbox, Label, Select} from "@rebass/forms";
import {Form, Formik} from "formik";
import axios from "axios";
import {VVPLayout, VVPLayoutsAPIResponse} from "../../../../../Types";
import {AuthContext, MessageType, TourContext} from "../../../../../Contexts";
import { MessageContext } from "../../../../../Contexts";
import {
  CardFooter,
  Modal,
  DateInput,
  RadioInput,
  SelectInput,
  CheckBoxInput
} from "../../../../../Components";

import {games, GameName} from "./GamesSettings";

export const GamesSettingsContainer: React.FC<{
  patient: Patient;
}> = ({patient}) => {

  const [activeGames, setActiveGames] = useState<GameName[]>(["Breaker", "Bubbles"])

  return (
    <Card>
      {Object.keys(games).map(gameName => <ExpandableCard gameName={gameName as GameName} key={"card " + gameName}/>)}
    </Card>
  )
}

const ExpandableCard: React.FC<{
  gameName: GameName
}> = ({gameName}) => {

  const [isOpen, setIsOpen] = useState<boolean>(false)

  const primaryColor = games[gameName].color
  const secondaryColor = games[gameName].color + "20"

  return (
    <div style={{margin: "18px", boxShadow: "0 0 10px rgb(0 0 0 / 12%)"}}>
      <Flex alignItems="center" alignContent="center" sx={{cursor: "pointer"}}
            onClick={(e) => {
              setIsOpen(!isOpen)
            }}
            justifyItems="space-between" justifyContent="space-between"
            backgroundColor={primaryColor}
      >
        <Text fontWeight="bold" fontSize={5} color="white" padding={2} paddingLeft={4}>{gameName}</Text>
        <Text fontWeight="bold" fontSize={3} color="white" padding={2} paddingRight={4}>Edit Settings</Text>
      </Flex>

      {isOpen?
        games[gameName].setting
        : undefined}
    </div>
  );
}
